import {userStore} from '@js/stores/userStore';

// The paywall a ride save refused with (Rides::StoreService flags on the 422), or null.
export const rideLimitFunctionality = (errors) => {
    if (errors?.ride_max_count_reached) {
        return 'ride_max_count';
    }

    if (errors?.ride_max_duration_reached) {
        return 'ride_max_duration';
    }

    return null;
};

// The planned-ride cap in whole hours (flag `ride_max_duration`, seconds), as the paywall shows it.
export const rideMaxDurationHours = (seconds) => Math.round((Number(seconds) || 0) / 3600);

// Seconds from a form duration: a number of seconds, or a chrono "H:MM[:SS]".
const _durationSeconds = (value) => {
    if (value === null || value === undefined || value === '') {
        return 0;
    }

    const text = String(value).trim();
    if (!text.includes(':')) {
        return Number(text) || 0;
    }

    const [hours, minutes = 0, seconds = 0] = text.split(':').map((part) => Number(part) || 0);

    return (hours * 3600) + (minutes * 60) + seconds;
};

// Same as RidesHelper#planned_total_duration: the sent duration, or — a typed speed sends none —
// distance / speed plus the pauses.
const _plannedTotalSeconds = (rideData) => {
    const duration = _durationSeconds(rideData.get('ride[duration]'));
    if (duration) {
        return duration;
    }

    const distance = Number(rideData.get('ride[distance]')) || 0;
    // The LAST value, as Rails reads it: a miles account sends the typed mph, then its km/h.
    const speed = Number(rideData.getAll('ride[speed]').at(-1)) || 0;
    if (!distance || !speed) {
        return 0;
    }

    return Math.round(((distance / 1000) / speed) * 3600) + (Number(rideData.get('ride[break_time]')) || 0);
};

// Same rule as RidesHelper#ride_max_duration_reached?, checked before sending: a PLANNED ride longer
// than the role's cap (`ride_max_duration`, seconds, pauses included). A recording, or a ride built
// from an imported file, is never refused — it was walked.
export const exceedsPlannedDuration = (rideData, currentDuration = 0) => {
    const maxDuration = Number(userStore.featureFlags?.ride_max_duration) || 0;
    if (!maxDuration || !rideData?.get) {
        return false;
    }

    if ([true, 'true'].includes(rideData.get('ride[recorded]'))) {
        return false;
    }

    for (const [field, value] of rideData.entries()) {
        if (field.startsWith('ride[import_ids]') && value) {
            return false;
        }
    }

    // An update is refused only when it LENGTHENS the ride (owner's call, same as the server).
    const planned = _plannedTotalSeconds(rideData);

    return planned > maxDuration && planned > (Number(currentDuration) || 0);
};
